import type { ProductListingPage } from "@decocms/apps-commerce/types";
import { ProductGallery } from "~/components/ui/store/ProductGallery";
import { ProductQuantity } from "~/components/ui/store/ProductQuantity";
import { ProductOrderBy } from "~/components/ui/store/ProductOrderBy";
import URLtoBreadcrumb from "~/sdk/URLtoBreadcrumb";
import trimProductForShelf from "~/sdk/trimProductForShelf";
import Pagination from "~/components/ui/Pagination";
import Breadcrumb from "~/components/ui/Breadcrumb";
import { type SectionProps as SectionProps } from "~/types/deco";
export interface ProductGallerySectionProps {
    /**
     * @title Galeria de Produtos
     * @description Faça aqui a configuração de produtos
     */
    page: ProductListingPage | null;
}
export function loader(props: ProductGallerySectionProps & { __pageUrl?: string; isMobile?: boolean }) {
    const { page } = props;
    return {
        ...props,
        // Immutable copy: the resolved ProductListingPage is memo-shared with
        // PageSEO's JSON-LD (bots need full variants). See ~/sdk/trimProductForShelf.
        page: page && { ...page, products: page.products.map(trimProductForShelf) },
        isMobile: props.isMobile ?? false,
        requestURL: props.__pageUrl ?? "/",
    };
}
const ProductGallerySection = (props: SectionProps<typeof loader>) => {
    const { page, requestURL, isMobile } = props;
    if (!page || !page.products.length)
        return null;
    return (<div className='px-2 w-full max-w-[1810px] mx-auto'>
            <div className='mb-2 lg:my-4'>
                <Breadcrumb itemListElement={URLtoBreadcrumb(requestURL)}/>
            </div>

            {!isMobile && (<div className='bg-neutral-200 rounded pl-4 pr-3 h-12 flex items-center justify-center lg:justify-between'>
                    <ProductQuantity quantity={page.products.length}/>
                    <Pagination url={requestURL} pageInfo={page.pageInfo}/>
                    <ProductOrderBy url={requestURL} sortOptions={page.sortOptions}/>
                </div>)}
            {isMobile && (<>
                    <div className='mb-2'>
                        <ProductQuantity quantity={page.products.length}/>
                    </div>
                    <ProductOrderBy url={requestURL} sortOptions={page.sortOptions} isMobile/>
                </>)}
            <div className='my-2'>
                <ProductGallery products={page.products} isMobile={isMobile}/>
            </div>
            <div className='bg-neutral-200 rounded flex items-center justify-center h-12 my-4'>
                <Pagination url={requestURL} pageInfo={page.pageInfo}/>
            </div>
        </div>);
};
export default ProductGallerySection;
export { default as LoadingFallback } from "~/components/LoadingFallback";

export const sync = true;
